import React, { createContext, useState, useEffect } from "react";

export const LoginContext = createContext();

export const LoginContextProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [token, setToken] = useState(null);

  useEffect(() => {
    if (isLoggedIn && user) {
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("isVerified", isVerified.toString());
      localStorage.setItem("token", token);
    }
  }, [isLoggedIn, user, isVerified, token]);

  // Load data from localStorage on initial render
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedIsLoggedIn = localStorage.getItem("isLoggedIn");
    const storedIsVerified = localStorage.getItem("isVerified");
    const storedToken = localStorage.getItem("token");

    if (storedUser && storedIsLoggedIn === "true") {
      setUser(JSON.parse(storedUser));
      setIsLoggedIn(true);
      setIsVerified(storedIsVerified === "true");
      if (storedToken) {
        setToken(storedToken);
      }
    }
  }, []);

  // Function to clear localStorage during logout
  const clearStorage = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("isVerified");
    localStorage.removeItem("token");
  };

  return (
    <LoginContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        user,
        setUser,
        isVerified,
        setIsVerified,
        token,
        setToken,
        clearStorage,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};
